import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import messages from '../../../locale/messages';
import ManageCategory from './ManageCategory';

function action({ store, intl, params }) {
    const title = intl.formatMessage(messages.editManageServices);
    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    if (!isAdminAuthenticated) {
        return { redirect: '/login' };
    }

    const profileId = Number(params.id)
        return {
            title,
            component: (
                <AdminLayout>
                    <ManageCategory id={profileId} />
                </AdminLayout>
            ),
        };
}

export default action;
